import { Component, OnInit, TemplateRef, ViewChild, effect } from '@angular/core';
import { FormControl, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TeamManagementService } from 'src/app/_services/new-settings/team-management.service';
import { TeamCreditsService } from 'src/app/_services/team-credits.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import _ from 'underscore';

@Component({
    selector: 'app-team-management',
    templateUrl: './team-management.component.html',
    styleUrls: ['./team-management.component.scss'],
    standalone: false
})
export class TeamManagementComponent implements OnInit {

  teanEmptyState: Boolean = false;
  showYourTeamTab: Boolean = true;
  showPendingTab: Boolean = false;
  showInvitationTab: Boolean = false;
  planDetails: any;
  alllist: any[] = [];
  tabList: any[] = [];
  adminDetails: any;
  pendingListCount: Number = 0;
  teamListCount: Number = 0;
  InvitationListCount: Number = 0;
  selectedTeams: Object[] = [];
  selected: boolean;
  successMessage: string = '';
  errorMessage: string = '';
  infoMessage: string = '';
  userRemindLaterInvites: Object[] = [];

  searchInput: UntypedFormControl = new UntypedFormControl(null);

  creditInput: UntypedFormControl = new UntypedFormControl(null);
  creditExceedError: boolean = false;
  creditBelowError: boolean = false;

  emailInput: UntypedFormControl = new UntypedFormControl(null);
  emailInputError: Boolean = false;

  roleInput: UntypedFormControl = new UntypedFormControl(null);
  roleInputError: Boolean = false;
  roleType: string | null = null;

  sendTeamToAPI: any[] = [];
  invitelink: any;

  showSpinnerLoader: Boolean = false;
  showInviteSpinner: Boolean = false;
  showTeamLeaveSpinner: Boolean = false;
  autopilotAccessControl: UntypedFormControl = new UntypedFormControl(false);
  isaiSourcingEnabled: boolean = false;

  transferAdminTarget: any = null;
  transferConfirmInput: FormControl = new FormControl('');
  /** Optional reason for the transfer, stored only in the activity log */
  transferReasonInput: FormControl = new FormControl('', [Validators.maxLength(100)]);
  showTransferAdminSpinner: Boolean = false;
  transferAdminErrorMessage: string = '';
  readonly transferConfirmPhrase = 'TRANSFER';

  get transferConfirmValue(): string {
    return (this.transferConfirmInput.value || '').trim();
  }

  @ViewChild('addCreditToUser') addCreditToUser: TemplateRef<any>;
  @ViewChild('deleteUserModel') deleteUserModel: TemplateRef<any>;
  @ViewChild('revokeUserModel') revokeUserModel: TemplateRef<any>;
  @ViewChild('acceptInvitationModel') acceptInvitationModel: TemplateRef<any>;
  @ViewChild('rejectInvitationModel') rejectInvitationModel: TemplateRef<any>;
  @ViewChild('leaveteam') leaveteam: TemplateRef<any>;
  @ViewChild('transferAdminModel') transferAdminModel: TemplateRef<any>;

  constructor(
    private teammanagementservice: TeamManagementService,
    private transactionService: TransactionService,
    private localstorageservice: LocalStorageService,
    private modalService: NgbModal,
    private teamservice : TeamCreditsService,
    private aiSourcingService: AiSourcingService
  ) {
    effect(() => {
      const creditsData = this.transactionService.credits();
      const accessData = this.transactionService.access();
      // isteamadmin specifically comes from the access signal when available - access is
      // refreshed on every navigation to this route (AccessRefreshGuard), while credits is only
      // refetched on login/credit-consuming actions, so relying on credits alone left a newly
      // promoted admin's own UI stale until a full page reload (TRMS: admin-transfer UI refresh).
      this.planDetails = {
        ...(creditsData || {}),
        isteamadmin: accessData?.isteamadmin ?? creditsData?.isteamadmin
      };
      this.isaiSourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess');
    });
  }

  ngOnInit() {

    this.fetchInviteTeamMembers();
    this.getInviteLink();
    this.fetchUserRemindLaterInvites();

    this.searchInput.valueChanges.subscribe((value: string) => {
      const searchValue = value?.toLowerCase() || '';
      this.tabList = this.alllist?.filter((res) =>
        (res.firstname?.toLowerCase().includes(searchValue) ||
          res.lastname?.toLowerCase().includes(searchValue) ||
          res.inviteeemailid?.toLowerCase().includes(searchValue)) &&
        (this.showYourTeamTab ? res.invitestatus === 'accepted' : res.invitestatus === 'sent')
      );
    });


    this.creditInput.valueChanges.subscribe((value) => {
      if(value && Number(value) < 1) {
        this.creditBelowError = true;
      } else if ((Number(value) * this.sendTeamToAPI.length) > this.planDetails?.pooledbalancebasiccontactenrichmentcredits) {
        this.creditExceedError = true;
      } else {
        this.creditExceedError = false;
        this.creditBelowError = false;
      }
    });

    this.emailInput.valueChanges.subscribe((value) => {
      const emailRegex = /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/;
      if (!value?.trim() || emailRegex.test(value)) {
        this.emailInputError = false;
      } else {
        this.emailInputError = true;
      }
    });

  };

  /**
   * Fetch User All Remind Later Invites
   */
  fetchUserRemindLaterInvites() {
    this.teammanagementservice.fetchUserRemindLaterInvites().subscribe((res: any) => {
      if (res.status == 'success') {
        const now = new Date();
        this.userRemindLaterInvites = res.message.map((invite: any) => {
          const createdDate = new Date(invite.createdon);
          const diffInMs = now.getTime() - createdDate.getTime();
          const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
          if (diffInDays > 30) {
            return { ...invite, expired: true };
          } else {
            return { ...invite, expired: false };
          }
        });
        this.InvitationListCount = res?.message.length;
      } else {
        this.userRemindLaterInvites = [];
        this.InvitationListCount = 0;
      }
    })
  };

  /**
   * Get current plan details
   */
  fetchPlanDetails() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const creditsData = this.transactionService.credits();
    if (creditsData) {
      this.planDetails = creditsData;
      this.isaiSourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess');
    } else {
      this.planDetails = {};
    }
  };


/**
 * Get invite link
 */
  getInviteLink() {
       this.teammanagementservice.fetchteaminvitelink().subscribe((res: any) => {
      if (res.status == 'success') {
        this.invitelink = res.inviteurl
      }
    })
  }


  /**
   * Copy invite link
   */
  copyinvitelink() {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = this.invitelink
    inp.select();
    document.execCommand('copy', false);
    inp.remove();
    this.successMessage = 'Link copied succesfully';
    setTimeout(() => this.successMessage = '', 5000);
  }


  /**
   * Get all the invite team members
   */
  fetchInviteTeamMembers(onPageRefresh: Boolean = true) {

    const index = "0";

    this.teammanagementservice.fetchallteaminvites(index).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.alllist = res.teaminvitesarray;
        if (res.teamAdminDetails && res.teamAdminDetails?.firstname) {
          this.adminDetails = res.teamAdminDetails;
        } else {
          this.adminDetails = null;
        }
        // this.adminDetails['selected'] = false;
        if(onPageRefresh) {
          this.tabList = this.alllist?.filter((res: any) => res.invitestatus == 'accepted');
          this.teamListCount = this.alllist?.filter((res: any) => res.invitestatus == 'accepted').length;
          this.teamListCount = Number(this.teamListCount) + Number(this.adminDetails ? 1 : 0);
          this.pendingListCount = this.alllist?.filter((res: any) => res.invitestatus == 'sent').length;
        } else {
          const tabChangeAction = this.showPendingTab ? 'pending' : this.showYourTeamTab ? 'your-team' : this.showInvitationTab ? 'your-team' : 'your-team';
          this.showPendingTab = this.showPendingTab;
          this.showYourTeamTab = this.showYourTeamTab;
          this.showInvitationTab = this.showInvitationTab;
          this.onTabChange(tabChangeAction);
        }

      } else {
        this.alllist = [];
        this.adminDetails = null;
      }

    })

  };

  /**
   * Select role
   * @param event
   */
  selectRole(event: any) {
    this.roleType = event.target.value;
    this.roleInputError = false;
  };

  /**
   * Send Invite
   */
  sendInvite() {
    if (!this.emailInput?.value && !this.roleType) {
      this.emailInputError = true;
      this.roleInputError = true;
      return
    } else if (!this.emailInput?.value) {
      this.emailInputError = true;
      return
    } else if (!this.roleType) {
      this.roleInputError = true;
      return
    } else {
      this.emailInputError = false;
      this.roleInputError = false;
    };

    const data = {
      userdetailsarray: [{
        emailid: this.emailInput.value,
        role: this.roleType,
        contactenrichmentusagelimit: 0,
        basiccontactenrichmentusagelimit: 0
      }]
    };

    this.showInviteSpinner = true;

    this.teammanagementservice.sendteaminviteviaemail(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.showPendingTab = true;
        this.showYourTeamTab = false;
        this.showInvitationTab = false;
        this.fetchInviteTeamMembers(false);
        this.successMessage = 'Invite Sent Successfully!';
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        if (res && res.message == 'User already invited') {
          this.errorMessage = 'User already invited';
          setTimeout(() => this.errorMessage = '', 5000);
        } else if(res && res.message == 'Maximum Team Invite Limit Reached') {
          this.errorMessage = 'You have reached the maximum team invite limit';
          setTimeout(() => this.errorMessage = '', 5000);
        } else {
          this.errorMessage = 'Something went wrong';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      }
      this.showInviteSpinner = false;
      this.roleType = null;
      this.emailInputError = false;
      this.emailInput.setValue(null);
    });

  };


  /**
 * Change Tab
 * @param tab
 */
  onTabChange(tab: string) {
    switch (tab) {
      case 'your-team': {
        this.showYourTeamTab = true;
        this.showPendingTab = false;
        this.showInvitationTab = false;
        this.tabList = this.alllist?.filter((res: any) => res.invitestatus == 'accepted');
        this.teamListCount = this.alllist?.filter((res: any) => res.invitestatus == 'accepted').length;
        this.teamListCount = this.alllist?.filter((res: any) => res.invitestatus == 'accepted').length;
        this.teamListCount = Number(this.teamListCount) + Number(this.adminDetails ? 1 : 0);
        this.pendingListCount = this.alllist?.filter((res: any) => res.invitestatus == 'sent').length;
        break;
      }

      case 'pending': {
        this.showYourTeamTab = false;
        this.showPendingTab = true;
        this.showInvitationTab = false;
        this.tabList = this.alllist?.filter((res: any) => res.invitestatus == 'sent');
        const now = new Date();
        this.tabList = this.tabList?.map((invite: any) => {
          const createdDate = new Date(invite.createdon);
          const diffInMs = now.getTime() - createdDate.getTime();
          const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
          if (diffInDays > 30) {
            return { ...invite, expired: true };
          } else {
            return { ...invite, expired: false };
          }
        });
        this.pendingListCount = this.alllist?.filter((res: any) => res.invitestatus == 'sent').length;
        this.teamListCount = this.alllist?.filter((res: any) => res.invitestatus == 'accepted').length;
        this.teamListCount = Number(this.teamListCount) + Number(this.adminDetails ? 1 : 0);
        break;
      }

      case 'invitation': {
        this.showYourTeamTab = false;
        this.showPendingTab = false;
        this.showInvitationTab = true;
        break;
      }
    }
    this.tabList.forEach((element, index) => {
      this.tabList[index].selected = false;
      this.selectedTeams = [];
      this.selected = false;
    })
  };

  /**
    * Delete all talentpools
    * @param talentpool
    * @param value
    */
  selectAll(value: Boolean) {
    if (value == true) {
      this.selectedTeams = []
      this.tabList.forEach((element, index) => {
        this.tabList[index].selected = true;
        this.selectedTeams.push(element);
      })
      // this.adminDetails['selected'] = true;
      // this.selectedTeams.push(this.adminDetails);
    } else if (value == false) {
      this.tabList.forEach((element, index) => {
        this.tabList[index].selected = false;
        this.selectedTeams = [];
      })
      // this.adminDetails['selected'] = false;
    }
  }

  /**
   * Single selected
   * @param talentpool
   * @param value
   */

  checkIfAllSelected(team: any, value: Boolean) {
    if (value == true) {
      this.selectedTeams.push(team);
      if (this.selectedTeams.length == this.tabList.length) {
        this.selected = true
      }
    } else {
      this.selectedTeams = _.without(this.selectedTeams, team.role);
      this.selectedTeams = this.selectedTeams.filter((t: any) => t.role != team.role);
      this.selected = false
    }
  }

  /**
   * Delete Candidate
   * @param team
   */
  deleteCandidate(team: Object) {
    if (team) {
      this.sendTeamToAPI.push(team)
    } else {
      this.sendTeamToAPI = this.selectedTeams;
    }
    this.modalService.open(this.deleteUserModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Add coin to the Candidate
   * @param team
   */
  addCoinToCandidate(team: Object) {
    if (team) {
      this.sendTeamToAPI.push(team)
    } else {
      this.sendTeamToAPI = this.selectedTeams;
    }

    this.modalService.open(this.addCreditToUser, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  /**
   * Revoke Invitation
   * @param team - selected team member
   */
  revokeInvitation(team: Object) {
    if (team) {
      this.sendTeamToAPI.push(team)
    } else {
      this.sendTeamToAPI = this.selectedTeams;
    }
    this.modalService.open(this.revokeUserModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }


  /**
   * Delete candidate from the team api call
   */
  deleteCandidateFromTeam() {

    const data = {
      teaminviteidsarray: this.sendTeamToAPI.map((res: any) => res.teaminviteid)
    }
    this.showSpinnerLoader = true;
    this.teammanagementservice.removemember(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Candidate Removed Successfully!';
        this.fetchInviteTeamMembers(false);
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.dismiss();
      this.showSpinnerLoader = false;
    })
  };


  /**
 * Add Coin to the candidate api call
 */
  addCoinToCandidateAPI() {

    if (!this.creditInput?.value) return;

    this.showSpinnerLoader = true;
    const data = {
      memberemailidsarray: this.sendTeamToAPI.map((res: any) => res.inviteeemailid || res.loginemail),
      basiccontactcreditscount: this.creditInput?.value,
      contactcreditscount: 0
    }

    this.teammanagementservice.updateCredit(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Credit Updated Successfully!';
        this.fetchInviteTeamMembers(false);
        this.fetchPlanDetails();
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
      this.dismiss();
    })
  }


  /**
   * Add coin to the admin
   * @returns
   */
  addCoinToAdminAPI() {
    if (!this.creditInput?.value) return;
    this.showSpinnerLoader = true;
    const data = {
      numberofbasiccontactcredits: this.creditInput?.value,
      numberofcontactcredits: 0
    }

    this.teammanagementservice.reserveAdminCredit(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Credit Updated Successfully!';
        this.fetchInviteTeamMembers(false);
        this.fetchPlanDetails();
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
      this.dismiss();
    })
  };

  /**
 * Revoke Candidate from the team api call
 */
  revokeInvitationAPI() {

    const data = {
      teaminviteidsarray: this.sendTeamToAPI.map((res: any) => res.teaminviteid)
    }
    this.showSpinnerLoader = true;
    this.teammanagementservice.revokeCandidateInvitation(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.fetchInviteTeamMembers(false);
        this.successMessage = 'Candidate Invitation Revoke Successfully!';
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
    this.showSpinnerLoader = false;
    })

  }

  /**
   * Reject Invitation Model
   */
  openRejectInvitationModel(team: Object) {
    if (team) {
      this.sendTeamToAPI.push(team)
    } else {
      this.sendTeamToAPI = this.selectedTeams;
    }
    this.modalService.open(this.rejectInvitationModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  /**
   * Accept invitation Model
   */
  openConfirmInvitationModel(team: Object) {
    if (team) {
      this.sendTeamToAPI.push(team)
    } else {
      this.sendTeamToAPI = this.selectedTeams;
    }
    this.modalService.open(this.acceptInvitationModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  /**
   * Accept Invitation
   */
  acceptInvitation() {

    this.showSpinnerLoader = true;
    let data = {
      teamadminemailid: this.sendTeamToAPI[0]?.adminemail,
      invitestatus: 'accepted'
    }
    this.teammanagementservice.teamInviteResponse(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Team Invitation Accepted Successfully!';
        this.fetchUserRemindLaterInvites();
        this.fetchInviteTeamMembers(false);
        setTimeout(() => this.successMessage = '', 5000);
      } else if (res.status == 'failure' && res.message == 'User is already part of some team') {
        this.infoMessage = 'You are already part of a team, Leave the team to accept the invitation.!';
        setTimeout(() => this.infoMessage = '', 5000);
      } else if (res.status == 'failure' && res.message == 'User is already team admin') {
        this.infoMessage = 'You are already part of a team, Leave the team to accept the invitation.!';
        setTimeout(() => this.infoMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
      this.dismiss();
    })
  };

  /**
   * Reject Invitation
   */
  rejectInvitation() {

    this.showSpinnerLoader = true;
     let data = {
      teamadminemailid: this.sendTeamToAPI[0]?.adminemail,
      invitestatus: 'rejected'
    }
    this.teammanagementservice.teamInviteResponse(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.fetchUserRemindLaterInvites();
        this.successMessage = 'Team Invitation Rejected Successfully!';
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
      this.dismiss();
    })
  }

  /**
   * Open Leave Team Model
   */
  leaveteammodal() {
    this.modalService.open(this.leaveteam, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Leave Team API Call
   */
  submitleaveteam() {
    this.showTeamLeaveSpinner = true;
    this.teamservice.leaveteamlink().subscribe((res: any) => {
      if (res.status == 'success') {
        this.successMessage = 'Team left succesfully';
        setTimeout(() => this.successMessage = '', 5000);
        this.fetchPlanDetails()
        this.dismiss();
      } else {
        this.successMessage = 'Something Went Wrong';
        setTimeout(() => this.successMessage = '', 5000);
      }
      this.showTeamLeaveSpinner = false;
    })
  };

  /**
  * Dismiss model
  */
  dismiss() {
    this.modalService.dismissAll();
    this.sendTeamToAPI = [];
    this.showSpinnerLoader = false;
    this.creditInput.setValue(null);
    this.transferAdminTarget = null;
    this.transferConfirmInput.setValue('');
    this.transferReasonInput.setValue('');
    this.transferAdminErrorMessage = '';
  }

  openTransferAdminModal(team: any) {
    this.transferAdminTarget = team;
    this.transferConfirmInput.reset();
    this.transferReasonInput.reset('');
    this.transferAdminErrorMessage = '';
    this.modalService.open(this.transferAdminModel, {
      size: 'xs' as 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  confirmTransferAdmin() {
    if (!this.transferAdminTarget || this.transferConfirmValue !== this.transferConfirmPhrase || this.transferReasonInput.invalid) {
      return;
    }

    const { loginemail } = this.localstorageservice.getItem('userdata');

    this.showTransferAdminSpinner = true;
    this.transferAdminErrorMessage = '';

    const reason = (this.transferReasonInput.value || '').trim();

    // The current admin is never sent in the payload - the backend resolves them from the
    // verified session (req.user), never from client-supplied input, raw userid or otherwise.
    this.teammanagementservice.transferAdmin({
      futureAdminUserNumber: this.transferAdminTarget.teamUserNumber,
      reason: reason || undefined,
      operatorIdentifier: loginemail
    }).subscribe({
      next: (res: any) => {
        this.showTransferAdminSpinner = false;

        if (!res?.success) {
          this.transferAdminErrorMessage = res?.message || 'Something went wrong';
          return;
        }

        this.successMessage = `Admin role transferred to ${this.transferAdminTarget.firstname} ${this.transferAdminTarget.lastname} successfully!`;
        setTimeout(() => this.successMessage = '', 5000);

        this.dismiss();
        this.localstorageservice.setItem('role', 'teammember');
        this.localstorageservice.setItem('isteamAdmin', false);
        this.fetchPlanDetails();
        this.fetchInviteTeamMembers(false);
      },
      error: (err) => {
        this.showTransferAdminSpinner = false;
        this.transferAdminErrorMessage = err?.error?.message || 'Something went wrong';
      }
    });
  }


  toggleAutopilotAcces(team: any) {
    this.showSpinnerLoader = true;
    const payload = {
      data: [{
        loginemail: team?.inviteeemailid,
        autopilotaccess: !team?.hasaisourcingaccess
      }]
    }
    this.aiSourcingService.getAutopilotaccess(payload).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Autopilot Access Updated Successfully!';
        setTimeout(() => this.successMessage = '', 5000);
        this.fetchInviteTeamMembers(false)
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
    })
  }
}
